import { ReactComponent as IconLink } from "@/assets/svgs/icon-link.svg";
import Button from "@/components/Button/index";
import { useNavigate, useParams } from '@/lib/router-dom/index';

const SetupEtrIssuanceCard = () => {
	const { goTo } = useNavigate()
	const { useCaseId } = useParams()

	function goToEtrIssuancePage() {
		goTo(`/use-cases/${useCaseId}/edit-personas`)
	}
	return (
		<div className="layout-dashboard__block setup_etr_issuance__bg">
			<div className="label-text-link-icon__div">
				<div className="label-text-link-icon__div__icon">
					<IconLink />
				</div>
				<p className="setup_label__p">
					Setup blockchain selection and enable issuance of
					e-transferable records.
				</p>
			</div>
			<div className="layout_dashboard__etr_button">
				<Button
					text="Setup ETR Issuance"
					id="setup-etr-issuance-button"
					round
					full
					submit={() => goToEtrIssuancePage()}
				/>
			</div>
		</div>
	);
};

SetupEtrIssuanceCard.propTypes = {};

export default SetupEtrIssuanceCard;
